<div (click)="onTrocarParaEdicao()" class="inline__visualizacao" [ngClass]="{
        'inline__visualizacao--disabled': editorCtrl.disabled,
        'has-content': !!editorCtrl.value
    }" *ngIf="isLeitura$ | async" [innerHTML]="preVisualizacao | safe:'html'">
</div>

<ng-container *ngIf="!(isLeitura$ | async)">
    <gpe-editor-conteudo class="inline__editor" [full]="full" [config]="editorConfig" [formControl]="editorCtrl"
        [urlFileSave]="resourceEditor" [paramsUrlFileSave]="paramsResource" [heightDefault]="editorHeight"
        [label]="null" [resizeEnabled]="resizeEnabled" (ready)="onReady()" (setBlur)="onBlur($event)">
    </gpe-editor-conteudo>
    <div class="inline__options d-flex justify-content-end pt-1">
        <button type="button" class="btn btn-sm btn-icon btn-light-dark mr-2">
            <span class="svg-icon svg-icon-md">
                <gpe-check></gpe-check>
            </span>
        </button>
    </div>
</ng-container>